import { type ComponentDiagnostic } from "@swot/base-components";
import { adminConfigFor } from "@cmts/admin/index.js";
import { CmtsAdminResourcePage } from "@components/admin/index.js";

/**
 * Delegates to CmtsAdminResourcePage, the canonical interactive administration surface.
 * The delegated surface renders CmtsSmartDataGrid for searchable/filterable records and
 * CmtsRoutingRuleCustomForm for the ultra-modern multi-section create/edit modal.
 */
export function CmtsRoutingAdminPage(props: {
  rows?: readonly Record<string, unknown>[] | undefined;
  diagnostics?: readonly ComponentDiagnostic[] | undefined;
  onUpsert?: ((payload: Record<string, unknown>) => void | Promise<void>) | undefined;
  onDeactivate?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  onReactivate?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  onTest?: ((row: Record<string, unknown>) => void | Promise<void>) | undefined;
  dependencyData?: Record<string, readonly Record<string, unknown>[]> | undefined;
  onRefresh?: (() => void | Promise<void>) | undefined;
}) {
  return (
    <CmtsAdminResourcePage
      config={adminConfigFor("routing")}
      rows={props.rows}
      diagnostics={props.diagnostics}
      dependencyData={props.dependencyData}
      onUpsert={props.onUpsert}
      onDeactivate={props.onDeactivate}
      onReactivate={props.onReactivate}
      onTest={props.onTest}
      onRefresh={props.onRefresh}
    />
  );
}
